export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_05.6c01cc87.png";